import React, { useContext } from 'react';
import './Disclaimer.scss';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts';

const Disclaimer = () => {
  const locId = useContext(LocaleContext);

  return (
    <div className="disclaimer">
      <hr aria-hidden />
      <p>{getText(locId, 'PersonalInfo', 'paragraph', 'Disclaimer')}</p>
    </div>
  );
};

export default Disclaimer;
